import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly ngZone = inject(NgZone);

  handleError(error: any): void {
    try {
      if (error instanceof HttpErrorResponse) {
        console.error('[Global Error]', 'HTTP', error.status, error.message, error.error);
        return;
      }

      if (error && error.rejection instanceof HttpErrorResponse) {
        const http = error.rejection as HttpErrorResponse;
        console.error('[Global Error]', 'Unhandled Promise Rejection', http.status, http.message, http.error);
        return;
      }

      if (error && error.rejection) {
        console.error('[Global Error]', 'Unhandled Promise Rejection', error.rejection);
        return;
      }

      console.error('[Global Error]', error);
    } catch (e) {
      console.error('[Global Error] handler failure', e);
    }
  }
}
